import dosificadoradepolvos1 from '../dosificadoradepolvos/dosificadoradepolvos1.png'


const imagedosificadoradepolvos = [
    dosificadoradepolvos1,
]

export default imagedosificadoradepolvos